<template>
  <filter-summary
    icon="calendar"
    title="期間"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
    >{{ summary }}</filter-summary
  >
</template>

<script>
import { toHumanFriendlyFormat } from '@/util/date'

import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「期間」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    dateFrom: {
      type: String,
    },
    dateTo: {
      type: String,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    summary() {
      if (this.dateFrom && this.dateTo) {
        return (
          toHumanFriendlyFormat(this.dateFrom) +
          ' ～ ' +
          toHumanFriendlyFormat(this.dateTo)
        )
      } else {
        return ''
      }
    },
  },
}
</script>
